<template>
  <div>
    <div
      v-if="showPicker"
      class="modal-backdrop open"
      role="dialog"
      aria-modal="true"
      @click.self="$emit('close-picker')"
    >
      <div class="modal">
        <div class="row">
          <h2>{{ pickTitle }}</h2>
          <button type="button" class="close" aria-label="关闭" @click="$emit('close-picker')">
            ×
          </button>
        </div>
        <p class="subtext">{{ pickSub }}</p>
        <button
          v-for="wallet in wallets"
          :key="wallet.catalogId"
          type="button"
          class="btn full"
          :disabled="!wallet.info.uuid"
          style="margin-bottom: 10px"
          @click="$emit('select-wallet', wallet)"
        >
          {{ wallet.info.name }}
          <span v-if="!wallet.info.uuid" class="subtext"> — {{ notInstalled }}</span>
        </button>
      </div>
    </div>
    <div
      v-if="showDisconnect"
      class="modal-backdrop open"
      role="dialog"
      aria-modal="true"
      @click.self="$emit('close-disconnect')"
    >
      <div class="modal">
        <div class="row">
          <h2>{{ connectedTitle }}</h2>
          <button type="button" class="close" aria-label="关闭" @click="$emit('close-disconnect')">
            ×
          </button>
        </div>
        <p class="subtext" style="word-break: break-all">{{ address }}</p>
        <button type="button" class="btn gold full" style="margin-top: 20px" @click="$emit('disconnect')">
          {{ disconnectLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilmWalletModals",
  props: {
    showPicker: Boolean,
    showDisconnect: Boolean,
    wallets: { type: Array, default: () => [] },
    address: { type: String, default: "" },
    pickTitle: { type: String, default: "" },
    pickSub: { type: String, default: "" },
    notInstalled: { type: String, default: "" },
    connectedTitle: { type: String, default: "" },
    disconnectLabel: { type: String, default: "" },
  },
};
</script>
